﻿export class request_login_contact {
    public contact_id: string | null = null;
    public first_name: string | null = null;
    public second_name: string | null = null;
    public email: string | null = null;
}